import React from 'react';

interface ControlsProps {
  onUndo: () => void;
  canUndo: boolean;
  onReset: () => void;
  isCompleted: boolean;
  stepCount: number;
  limit?: number;
  isFailed: boolean;
  moveInput: string;
  onMoveInputChange: (value: string) => void;
  onPlayback: () => void;
  onStopPlayback: () => void;
  isPlaying: boolean;
  onInputKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const Controls: React.FC<ControlsProps> = ({
  onUndo,
  canUndo,
  onReset,
  isCompleted,
  stepCount,
  limit,
  isFailed,
  moveInput,
  onMoveInputChange,
  onPlayback,
  onStopPlayback,
  isPlaying,
  onInputKeyDown,
}) => {
  return (
    <div style={styles.container}>
      {isCompleted && (
        <div style={styles.completed}>
          Level Completed!
        </div>
      )}
      
      {isFailed && (
        <div style={styles.failed}>
          Limit Reached!
        </div>
      )}
      
      {limit !== undefined && !isCompleted && !isFailed && (
        <div style={styles.steps}>
          Steps: {stepCount} / {limit}
        </div>
      )}

      <div style={styles.playbackSection}>
        <input
          type="text"
          value={moveInput}
          onChange={(e) => onMoveInputChange(e.target.value.toLowerCase())}
          onKeyDown={onInputKeyDown}
          placeholder="Enter moves (u/d/l/r)"
          disabled={isPlaying}
          style={styles.input}
        />
        {isPlaying ? (
          <button onClick={onStopPlayback} style={styles.buttonSecondary}>
            Stop
          </button>
        ) : (
          <button onClick={onPlayback} style={styles.buttonSecondary}>
            Play
          </button>
        )}
      </div>
      
      <div style={styles.buttonGroup}>
        <button
          onClick={onUndo}
          disabled={!canUndo}
          style={{
            ...styles.button,
            ...(canUndo ? {} : styles.buttonDisabled),
          }}
        >
          Undo (Z)
        </button>
        
        <button
          onClick={onReset}
          style={styles.button}
        >
          Reset (R)
        </button>
      </div>
      
      <div style={styles.instructions}>
        <p><strong>Controls:</strong></p>
        <p>Arrow Keys or WASD - Move</p>
        <p>U/D/L/R - Move (in input field)</p>
        <p>Z - Undo</p>
        <p>R - Reset</p>
        <p>N - Next Level</p>
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '15px',
    backgroundColor: '#f5f5f5',
    borderRadius: '8px',
    border: '2px solid #ddd',
  },
  completed: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#27ae60',
    textAlign: 'center',
    padding: '10px',
    backgroundColor: '#d5f5e3',
    borderRadius: '4px',
  },
  failed: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#e74c3c',
    textAlign: 'center',
    padding: '10px',
    backgroundColor: '#fadbd8',
    borderRadius: '4px',
  },
  steps: {
    fontSize: '18px',
    textAlign: 'center',
    padding: '5px',
    color: '#666',
  },
  playbackSection: {
    display: 'flex',
    gap: '10px',
    alignItems: 'center',
  },
  input: {
    padding: '8px 12px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    flex: 1,
  },
  buttonGroup: {
    display: 'flex',
    gap: '10px',
  },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    cursor: 'pointer',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#3498db',
    color: '#fff',
    transition: 'background-color 0.2s',
  },
  buttonDisabled: {
    backgroundColor: '#bdc3c7',
    cursor: 'not-allowed',
  },
  buttonSecondary: {
    padding: '8px 16px',
    fontSize: '14px',
    cursor: 'pointer',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#9b59b6',
    color: '#fff',
    transition: 'background-color 0.2s',
  },
  instructions: {
    fontSize: '14px',
    color: '#666',
  },
};